import { sentryTag } from "@repo/utils";
import { useEffect } from "react";

export function useSentry() {
  useEffect(() => {
    try {
      if (import.meta.env.VITE__SENTRY_KEY) {
        window?.xdk?.sentry?.register(
          import.meta.env.VITE__SENTRY_KEY,
          sentryTag
        );
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error("Failed to register Sentry", e);
    }
  }, []);
}
